export const AUDIT_TABS = ["connections", "telemetry-recovery"] as const;

export type AuditTab = (typeof AUDIT_TABS)[number];

export const DEFAULT_AUDIT_TAB: AuditTab = "connections";

export function isAuditTab(value: unknown): value is AuditTab {
  return typeof value === "string" && (AUDIT_TABS as readonly string[]).includes(value);
}

/**
 * The umbrella page is /devices/:deviceId/audit and reads `?tab=`; the ticketed paths
 * /connections and /telemetry-recovery are aliases that pin the tab.
 */
export function resolveAuditTab(matchPath: string | undefined, search: string | undefined): AuditTab {
  const path = (matchPath || "").replace(/\/+$/, "");
  if (path.endsWith("/connections")) {
    return "connections";
  }
  if (path.endsWith("/telemetry-recovery")) {
    return "telemetry-recovery";
  }
  const fromQuery = new URLSearchParams(search || "").get("tab");
  return isAuditTab(fromQuery) ? fromQuery : DEFAULT_AUDIT_TAB;
}

/** URL for a tab of the umbrella page; the default tab needs no query. */
export function auditTabPath(deviceParam: string, tab: AuditTab): string {
  const base = `/devices/${deviceParam}/audit`;
  return tab === DEFAULT_AUDIT_TAB ? base : `${base}?tab=${tab}`;
}
